import ExportModal, { ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { LODGING_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Lodging/LodgingColumnsInfo'

export default function LodgingExportModal(props: ExportModalProps) {
  const dataTypeName = 'Lodging & Hospitality'

  const nursingHomeColumnHelper = createExportColumnHelper({
    columns: LODGING_COLUMNS,
  })

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        nursingHomeColumnHelper.retrieveColumn('name'),
        nursingHomeColumnHelper.retrieveColumn('city_summary'),
        nursingHomeColumnHelper.retrieveColumn('state_summary'),
        nursingHomeColumnHelper.retrieveColumn('zipcode_summary'),
        nursingHomeColumnHelper.retrieveColumn('domain'),
        nursingHomeColumnHelper.retrieveColumn('reviews_avg'),
        nursingHomeColumnHelper.retrieveColumn('reviews_cnt'),
        nursingHomeColumnHelper.retrieveColumn('open_hours'),
        nursingHomeColumnHelper.retrieveColumn('doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  return (
    <ExportModal
      title={`Select Columns for ${dataTypeName} Download`}
      subTitle={`Download up to 10,000 ${dataTypeName.toLocaleLowerCase()} at a time, with any of the following columns. Any filters already applied will remain active.`}
      submitText={`Export ${dataTypeName}`}
      columns={columns}
      {...props}
    />
  )
}
